module.exports = __webpack_public_path__ + "img/front_page_models.18fb24a4.svg";